import PropTypes from 'prop-types';
import React from 'react';

import {
  TileWithLoading,
  tileWithLoadingPropTypes,
} from '@react/Pages/AccountSettingsPage/YourDataSection/TileWithLoading';
import DetailsTile from '@react/Pages/AccountSettingsPage/YourDataSection/DetailsTile/DetailsTile';

const AccountDetailsTileBase = ({ account, dateTime, href }) => {
  const { name } = account;
  const { time, timezone } = dateTime;

  const fields = [
    {
      title: t('field.company-name'),
      values: [name],
      icon: 'icon-company',
    },
    {
      title: t('label.account-time-zone'),
      values: [timezone, time],
      icon: 'icon-clock',
    },
  ];

  return <DetailsTile title={t('label.account-details')} href={href} fields={fields} />;
};

AccountDetailsTileBase.propTypes = {
  account: PropTypes.shape({
    name: PropTypes.string,
  }),
  dateTime: PropTypes.shape({
    time: PropTypes.string,
    timezone: PropTypes.string,
  }),
  href: PropTypes.string,
};

const AccountDetailsTile = TileWithLoading(AccountDetailsTileBase);

AccountDetailsTile.propTypes = {
  ...AccountDetailsTileBase.propTypes,
  ...tileWithLoadingPropTypes,
};

export default AccountDetailsTile;
export { AccountDetailsTile, AccountDetailsTileBase };
